var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show && !_vm.hiddenEllipsis)?_c('div',{staticClass:"cpt-tooltip",style:(_vm.tooltipStyle)},[_c('div',{ref:"tooltip",staticClass:"tooltip",class:[
      _vm.popperClass,
      'placement-' + _vm.placement,
      _vm.pointer !== 'center' ? `pointer-${_vm.placement}-${_vm.pointer}` : '',
      {'no-ellipsis': _vm.autoEllipsis}
    ],style:(_vm.calPos)},[(_vm.tooltipText)?_c('div',{ref:"tooltip-text",staticClass:"tooltip-text",domProps:{"innerHTML":_vm._s(_vm.purifyHTML(_vm.tooltipText, {
        ADD_TAGS: ['img'],
        ADD_ATTR: ['data-emoji', 'src', 'alt', 'class', 'style', 'onerror'],
        ALLOW_DATA_ATTR: true  // 允许所有 data-* 属性
      }))}}):_vm._e(),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }